import { jsonResponseHandling } from '../fetch';
import {
    apiUrl,
    MONITORING_LEGACY_PATH,
    MONITORING_PATH,
    SERVICE_INFO_PATH,
    fetchWithSubscriptionKey,
} from '../api-manager';

const SERVICE_INFO_ROOT = `${SERVICE_INFO_PATH}/service-info`;

const appendIncludeFilteredRoutes = (url, includeFilteredRoutes = false) => {
    if (!includeFilteredRoutes) {
        return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}include_filtered_routes=true`;
};

export const getHistoryByStopId = (stopId, useNewMonitoring) => {
    const basePath = useNewMonitoring ? MONITORING_PATH : MONITORING_LEGACY_PATH;
    return fetchWithSubscriptionKey(apiUrl(`${basePath}/history?stop_id=${stopId}`), { method: 'GET' })
        .then(response => jsonResponseHandling(response));
};

export const getHistoryByVehicleId = (vehicleId, useNewMonitoring) => {
    const basePath = useNewMonitoring ? MONITORING_PATH : MONITORING_LEGACY_PATH;
    return fetchWithSubscriptionKey(apiUrl(`${basePath}/history?vehicle_id=${vehicleId}`), { method: 'GET' })
        .then(response => jsonResponseHandling(response));
};

export const getUpcomingByStopId = (stopId, useNewMonitoring) => {
    const basePath = useNewMonitoring ? MONITORING_PATH : MONITORING_LEGACY_PATH;
    return fetchWithSubscriptionKey(apiUrl(`${basePath}/upcoming?stop_id=${stopId}`), { method: 'GET' })
        .then(response => jsonResponseHandling(response));
};

export const getUpcomingByVehicleId = (vehicleId, useNewMonitoring) => {
    const basePath = useNewMonitoring ? MONITORING_PATH : MONITORING_LEGACY_PATH;
    return fetchWithSubscriptionKey(apiUrl(`${basePath}/upcoming?vehicle_id=${vehicleId}`), { method: 'GET' })
        .then(response => jsonResponseHandling(response));
};

export const getDeparturesByStopCode = (stopCode, includeFilteredRoutes = true) => fetchWithSubscriptionKey(
    appendIncludeFilteredRoutes(apiUrl(`${SERVICE_INFO_ROOT}/departures?stop_code=${stopCode}&scope=tripsData`), includeFilteredRoutes),
    { method: 'GET' },
)
    .then(response => jsonResponseHandling(response));

export const getVehiclesByTripId = (tripId, includeFilteredRoutes = true) => fetchWithSubscriptionKey(
    appendIncludeFilteredRoutes(apiUrl(`${SERVICE_INFO_ROOT}/vehicles/byTripId/${tripId}`), includeFilteredRoutes),
    { method: 'GET' },
)
    .then(response => jsonResponseHandling(response));
